import React, { useState } from "react";
import { buildReferralLink } from "../../../referral";
import { capture } from "../../../analytics";

// "Bring a friend" card (epic #293 phase 1): every member gets a
// personal /join link. Friends who use it carry the member's code
// through the join form (and signup), so David can see who brings
// people — the mechanics half of the referral loop. What a referral
// EARNS is phase 3 (David's call), so the copy promises nothing yet.

const InviteFriendCard = ({ userSub }) => {
  const [copied, setCopied] = useState(false);
  if (!userSub) return null;

  const link = buildReferralLink(userSub);
  const canNativeShare =
    typeof navigator !== "undefined" && typeof navigator.share === "function";

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
      capture("referral_link_shared", { method: "copy" });
    } catch (e) {
      // Clipboard can be blocked — select-able text below still works.
      window.prompt("Copy your invite link:", link);
    }
  };

  const shareLink = async () => {
    try {
      await navigator.share({
        title: "Active Beaches",
        text: "Come out with me to an Active Beaches event! 🏐🌴",
        url: link,
      });
      capture("referral_link_shared", { method: "native" });
    } catch (e) {
      // User dismissed the sheet — nothing to do.
    }
  };

  return (
    <div
      style={{
        background: "#f4faf5",
        border: "1px solid #bfe3c8",
        borderRadius: 10,
        padding: "14px 16px",
        marginBottom: 16,
      }}
    >
      <div style={{ fontWeight: 700, color: "#1f5e2e", marginBottom: 4 }}>
        🤝 Bring a friend
      </div>
      <div style={{ fontSize: 13.5, color: "#3a4150", marginBottom: 10 }}>
        Share your personal invite link — when a friend joins through it,
        we know they're with you.
      </div>
      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <code
          style={{
            background: "#fff",
            border: "1px solid #d7e3da",
            borderRadius: 6,
            padding: "7px 10px",
            fontSize: 12.5,
            color: "#2b5e3a",
            userSelect: "all",
            overflowWrap: "anywhere",
            flex: "1 1 220px",
          }}
        >
          {link}
        </code>
        <button
          type="button"
          onClick={copyLink}
          style={{
            padding: "8px 14px",
            background: copied ? "#1f7a3a" : "#fff",
            color: copied ? "#fff" : "#1f7a3a",
            border: "1px solid #1f7a3a",
            borderRadius: 6,
            fontWeight: 700,
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          {copied ? "Copied ✓" : "Copy"}
        </button>
        {canNativeShare && (
          <button
            type="button"
            onClick={shareLink}
            style={{
              padding: "8px 14px",
              background: "#1f7a3a",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            ↗ Share
          </button>
        )}
      </div>
    </div>
  );
};

export default InviteFriendCard;
